<template>
  <vx-card no-shadow>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      id="button-with-loading"
    >
      <!-- Img Row -->
      <!-- <div class="flex flex-wrap items-center mb-base">
      <div class="vx-col" id="avatar-col">
        <div class="img-container mb-4">
          <img :src="this.$store.state.user.id_card_photo" class="rounded w-full" />
        </div>
      </div>
      </div>-->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>User</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-validate="'required'"
              v-model="user"
              label="email"
              item-value="id"
              :options="users"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              name="User"
            />
            <span class="text-danger text-sm" v-show="errors.has('User')">{{
              errors.first("User")
            }}</span>
          </template>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Name"
            class="w-full"
            v-model="name"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Phone</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="phone"
            class="w-full"
            v-model="phone"
          />
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{
            errors.first("phone")
          }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Province</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="province"
              label="province"
              item-value="id"
              :options="provinces"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Kota</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="city"
              label="city_name"
              item-value="id"
              :options="cities"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Kecamatan</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="district"
              label="subdistrict_name"
              item-value="id"
              :options="districts"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Addres Detail</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Addres Detail"
            class="w-full"
            v-model="detail_address"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Addres Detail')"
            >{{ errors.first("Addres Detail") }}</span
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Logo</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            class="w-full"
            type="file"
            id="filexx"
            name="Photo"
            accept="image/x-png, image/jpeg, image/jpg"
            @change="onFileSelected"
          />
          <br />
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" button="submit">Save Changes</vs-button>
      </div>
    </form>
  </vx-card>
</template>

<script>
import axios from '../../../axios'
import axios120 from '../../../axios120'
import router from '../../../router'
import vSelect from 'vue-select'
export default {
  data() {
    return {
      provinces: [],
      userAuth: this.$store.state.user,
      name: '',
      phone: '',
      province: {},
      provinces: [],
      city: {},
      cities: [],
      district: {},
      districts: [],
      detail_address: '',
      photo: null,
      photos: [],
      users: [],
      user: {},
    }
  },
  mounted() {
    this.getUser()
    this.getProvince(1)

  },
  watch: {
    province(newValue, oldValue) {

      if (newValue.province_id != oldValue.province_id) {
        this.getCity(0)
      }


    },
    city(newValue, oldValue) {
      if (newValue.city_id != oldValue.city_id) {
        this.getSubdistrict(0)
      }

    },
  },
  methods: {
    onFileSelected(event) {
      this.photo = event.target.files[0]
    },
    onMultipleFileSelected(event) {

      console.log('lala')
      for (var i = 0; i < event.target.files.length; i++) {
        this.photos[i] = event.target.files[i];

      }
    },
    onSubmit() {
      var formData = new FormData();
      if (this.photo) {
        formData.append('photo', this.photo, this.photo.name)
      }
      else {
        this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
        return

      }
      formData.append('user_id', this.user.id)
      formData.append('name', this.name)
      formData.append('province_name', this.province.province)
      formData.append('province_id', this.province.province_id)
      formData.append('city_name', this.city.city_name)
      formData.append('city_id', this.city.city_id)
      formData.append('district_name', this.district.subdistrict_name)
      formData.append('district_id', this.district.subdistrict_id)
      formData.append('no_wa', this.phone)
      formData.append('detail_address', this.detail_address)
      this.$validator.validateAll().then(result => {
        if (result) {

          axios.post('ecommerce/web/store', formData)
            .then(res => {
              if (res.status != 200) {

                this.acceptAlert('warning', 'Sorry', 'Please complete input data!')
              } else {


                this.acceptAlert('success', 'Success', 'Success add company')
                router.push('/store')

              }


            })
            .catch(error => {
              console.log(error.response)

            })
        } else {
          this.acceptAlert('warning', 'Sorry', 'Please complete input data!')

        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },
    getUser() {
      //console.log('ini mounted')
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      axios120.get(`ecommerce/web/user?has_store=0&limit=1000`, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            console.log(res)
            this.users = res.data.data
          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })

    },

    getProvince(firstTime) {
      axios.get('ecommerce/web/shipment/province', {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.provinces = res.data
            this.province = res.data[0]

          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    getCity(firstTime) {
      axios.get('ecommerce/web/shipment/city/' + this.province.province_id, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            this.cities = res.data
            this.city = res.data[0]

          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    getSubdistrict(firstTime) {
      axios.get('ecommerce/web/shipment/subdistrict/' + this.city.city_id, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.districts = res.data

            this.district = this.districts[0]

          }


        })
        .catch(error => {
          console.log(error.response)

        })

    }

  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  components: {
    'v-select': vSelect,
  },
}
</script>
